import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'

const getConfig = (env = 'development') => {
  if (env === 'development' || env === 'alpha') {
    return {
      apiKey: 'AIzaSyCDc_XRtL73buN3dOkAvyNuFvMOib8Lmss',
      authDomain: 'c331f.tapkit.com',
      databaseURL: 'https://faraday-c331f.firebaseio.com',
      projectId: 'faraday-c331f',
      storageBucket: 'faraday-c331f.appspot.com',
      messagingSenderId: '382776185454',
      appId: '1:382776185454:web:59ac1a5213c001e9'
    }
  }

  if (env === 'beta') {
    return {
      apiKey: 'AIzaSyC-pY1-7mTzcOHmGeWIEqnLsIjXpRPPx4c',
      authDomain: 'faradayprod-7c890.firebaseapp.com',
      databaseURL: 'https://faradayprod-7c890.firebaseio.com',
      projectId: 'faradayprod-7c890',
      storageBucket: 'faradayprod-7c890.appspot.com',
      messagingSenderId: '507217459393',
      appId: '1:507217459393:web:f733b19a51ffc3f6773c40'
    }
  }

  if (env === 'production') {
    return {
      apiKey: 'AIzaSyCqmxLuhim24LNt0SZKJzx69FAquULiJ2I',
      authDomain: 'app.tapkit.com',
      databaseURL: 'https://faraday-live.firebaseio.com',
      projectId: 'faraday-live',
      storageBucket: 'faraday-live.appspot.com',
      messagingSenderId: '443398260350',
      appId: '1:443398260350:web:8c2470b9211de7c73dba2f'
    }
  }
}

if (process.env.VUE_APP_FIREBASE_ENV) {
  const config = getConfig(process.env.VUE_APP_FIREBASE_ENV)
  firebase.initializeApp(config)
  // if (window.location.hostname.includes('localhost')) {
  //   firebase.functions().useFunctionsEmulator('http://localhost:5001')
  // }
}

// Firebase utils
const db = firebase.database
const firestore = firebase.firestore
const auth = firebase.auth
const storage = firebase.storage
const functions = firebase.app().functions(process.env.VUE_APP_FIREBASE_REGION)

export {
  db,
  firestore,
  auth,
  functions,
  storage,
  getConfig
}
